angular.module('dealerware.web.data').factory('DealerwareIssueCollection', function ($http,Collection,DealerwareIssueModel,$q) {

    'use strict';
    var collection = new Collection({
        baseEndpoint: '/locations/:location_id/cars/:vehicle_id/issues',
        model: 'DealerwareIssueModel',
        customActions: {
            index: {
                method: 'GET',
                ignoreDefaultRootNodeResponse: true,
                ignoreDefaultAssociationMapper: true,
                params: { include_reservation: true }
            },
            forContract: {
                endpoint: '/locations/:location_id/reservations/:contract_id/issues',
                method: 'GET',
                ignoreDefaultRootNodeResponse: true,
                ignoreDefaultAssociationMapper: true,
                params: { include_car: true }
            }
        }
    });

    jQuery.extend(collection.prototype,{});

    return collection;
});